import React, { useEffect } from 'react'
import _ from 'lodash'
import DropdownFieldSearch from '../../../../../ui/DropdownFieldSearch'
import { styled } from '@mui/system'
import { CardHeader, Grid, Typography } from '@mui/material'
import { TextField } from '../../../../../ui'
import { generateUtilityClasses } from '@mui/material'
import { useFormState } from 'react-final-form'
import { useGetAccountingChartOfAccountCurrentMutation } from '../../../../../services'

const classes = generateUtilityClasses('Grid', ['root', 'row'])

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.row}`]: {
    margin: theme.spacing(1, 0, 2, 0),
  },
}))

interface Props {
  accountingApData?: any
}

type TOptions = {
  key: number
  value: string
}

const ServiceForm = ({ accountingApData }: Props) => {
  const { values } = useFormState()
  const [accountingCurrent, { data: accountingCurrentData }] = useGetAccountingChartOfAccountCurrentMutation()

  const options: TOptions[] =
    accountingApData
      ?.filter((item: any) => item.CompanyType === 'Service')
      .map((item: any) => ({
        key: item.ID,
        value: item.AccountNumberName,
      })) || []

  useEffect(() => {
    if (typeof values?.ServiceChartOfAccountAP === 'number') {
      accountingCurrent({
        uspChartOfAccountView: {
          currentID: values?.ServiceChartOfAccountAP,
          isAllowedSelectControlledAccount: true,
          isIncludeAccountsThatCannotBeSelected: false,
          isReturnAllCompanyTypes: false,
        },
      })
    }
  }, [values?.ServiceChartOfAccountAP])

  return (
    <>
      <CardHeader title='Service Department' />
      <Grid container spacing={2} px={3} pt={3}>
        <Grid item xs={12} sm={12}>
          <TextField name='ServiceAccountNumber' label='Account Number' fullWidth />
        </Grid>
        <Grid item xs={12} sm={12}>
          <DropdownFieldSearch
            name='ServiceChartOfAccountAP'
            label='Chart of Account - AP'
            options={options}
            initialValue={options?.length === 1 ? _.first(options)?.key : null}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <DropdownFieldSearch
            name='ServiceChartOfAccountBill'
            label='Chart of Account - Bill (default)'
            options={accountingCurrentData as any}
            optionKey='ChartOfAccountID'
            optionValue='AccountNumberName'
            fullWidth
          />
        </Grid>
      </Grid>
    </>
  )
}

export default ServiceForm
